const allowedAttributes = [ 'fill', 'shape-rendering', 'height', 'width', 'viewbox', 'style' ]; 

export default {
    allowedAttributes
}